import {
    Component, Input, OnInit, AfterViewInit, AfterViewChecked,
    OnChanges, ElementRef, ViewChild, ViewChildren, SimpleChange,
    SimpleChanges, OnDestroy, HostListener, QueryList, Output, EventEmitter
} from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, ValidatorFn, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpParams, HttpEventType, HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { throttleTime, filter, debounceTime } from 'rxjs/operators';

import { ChangeDetectorRef } from '@angular/core';

//import ResizeObserver from 'resize-observer-polyfill';

//import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

//import {ActiveToast, IndividualToastrConfig, ToastrService } from 'ngx-toaster';

//import { CarouselComponent } from 'ngx-bootstrap/carousel';


import { ToastrService } from 'ngx-toastr';

import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';
import { InactivityTimeoutService } from '../../services/inactivity.timeout.service';
import { UserPostsDataService } from '../../services/posts.service';
import { SessionService } from '../../services/session.service';
import { ScrollPositionService  } from '../../services/scroll-position.service';

import { QuoteModalComponent } from '../../modals/quote-modal/quote-modal.component';
import { ScoreModalComponent } from '../../modals/score-modal/score-modal.component';
import { GifModalComponent } from '../../modals/gif-modal/gif-modal.component';
import { PostFooterComponent } from '../insertable/post-footer/post-footer.component';


import  *  as Classes from '../../classes/models.classes'

//@Pipe({ name: 'safeHtml' })
//export class SafeHtmlPipe implements PipeTransform {
//    constructor(private sanitizer: DomSanitizer) { }

//    transform(value: string): string {
//        return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
//    }
//}

//@Pipe({ name: 'safeHtml' })
//export class SafeHtmlPipe implements PipeTransform {
//    constructor(private sanitizer: DomSanitizer) { }

//    transform(value: string): SafeHtml {
//        return this.sanitizer.bypassSecurityTrustHtml(value);
//    }
//}

@Component({
  selector: 'app-home-new',
  templateUrl: './home.component.html',
  styleUrls: ["./home.component.css"]
})
export class HomeComponent_New implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy, OnChanges{
    //@Input() Mode: string;

    @Output() postSaved: EventEmitter<void> = new EventEmitter<void>();

    @ViewChildren('postElement', { read: ElementRef }) postElements: QueryList<ElementRef>;

    @ViewChild('carousel', { static: false }) carousel: any;
    @ViewChild('footerComponent') footerComponent!: PostFooterComponent;

    @ViewChild('sidebar') sidebarParent!: ElementRef;
    @ViewChild('mainContent') mainContent!: ElementRef;
    @ViewChild('sidebarContent') sidebar!: ElementRef;


    @ViewChild('sidebarContent') sidebarRef!: ElementRef;

    @ViewChild('sidebar') sidebarParentRef!: ElementRef;

    @ViewChild('sidebar') sidebarWrapperRef!: ElementRef;

    private previousScrollY = 0;

    @ViewChild('sidebar', { static: true }) sidebarWrapper!: ElementRef;
    @ViewChild('sidebarContent', { static: true }) sidebarContent!: ElementRef;

    sidebarHeight: number = 0;
    viewportHeight: number = 0;
    marginTop: number = 0;
    lastScrollY: number = 0;
    maxMarginTop: number = 0;


    pinnedBottom: boolean = false;
    pinnedTop: boolean = false;

    sidebarReset: boolean = false;
    sidebarAtBottom: boolean = false;
    sidebarAtTop: boolean = true;



    // initial top of the sidebar parent relative to page
    private containerTop: number = 0;
    // the maximum translation allowed: container height minus sidebar height
    private maxTranslate: number = 0;

    // We'll store some measurements
    private initialSidebarTop = 0;
    private containerHeight = 0;

    // We track the container?s bounding box if needed

    private containerBottom = 0;

    // For storing old scroll values
    private lastScrollTop = 0;
    private isScrollingDown = true;


    private wasScrollingDown = true;

    maxOffset!: number;
    leftOffset!: number;

    private scrollPosition: [number, number] = [0, 0];
    private shouldRestoreScrollPosition = false;

    private scrollEventSubscription: Subscription;
    allPostsLoaded = false; // Flag to check if all posts are loaded

    UserPostsData: Array<Classes.ShortsPosts>;
    UserPostsDataContent: Classes.ShortsPostSave;
    userProfileStates = new Map<number, any>();

    ProfileIconImage: string;

    selectedFile: File | null = null;
    selectedFileUrl: string;

    UserID: number;
    Username: string;
    UserImg: string;
    /** Shown when api/content/logo returns 404 (e.g. SQL offline). */
    readonly avatarPlaceholder = 'assets/branding/avatar-placeholder.svg';
    isOwnProfile: boolean = false;

    currentPage = 1;
    pageSize = 10;
    isLoading = false;

    showProfileBox : boolean = false;
    showTooltip: boolean = false;

    selectedScoreTypeID: number | null = null;
    //showDetails: boolean = false;

    selectedScoreIndex: number | null = null;
    showDetailsIndex: number | null = null;

    //selectedScoreDetails: Classes.ScoreDetails | null = null;
    uniqueScoreTypes: Classes.ScoreDetails[] = [];

    selectedPostId: number | null = null;
    selectedScoreTypeId: number | null = null;

    selectedScoreTypeIDs: { [key: number]: number } = {};
    showDetails: { [key: number]: boolean } = {};
    selectedScoreDetails: { [key: number]: Classes.ScoreDetails[] } = {};

    reactions: any = {};

    timeoutDuration: number = 600000; // 10 minutes in milliseconds

    postContent: string = '';

    userProfileVisible = false;
    hoverBoxStyle = {};
    userProfile: any = {};
    hoverTimer: any; // To hold the timer reference
    private timeoutId: any; // Holds the reference to the timeout

    private isTwitterWidgetsLoaded = false;

    private scrollEvent = new Subject<void>();
    public replyType: number = 1; // Default to 'Everyone'
    replyTypes = [
        { id: 1, text: 'Everyone', icon: 'path/to/everyone.svg' },
        { id: 2, text: 'Accounts You Follow', icon: 'path/to/accounts-follow.svg' },
        { id: 3, text: 'Verified Accounts', icon: 'path/to/verified-accounts.svg' },
        { id: 4, text: 'Only Accounts You Mention', icon: 'path/to/accounts-mention.svg' }
    ];

    selectedReplyType = this.replyTypes[0];  // default to Everyone

    //bootstrap: any;

    selectedGifUrl: string;
    isPlaying: boolean[] = []; // Array to manage play state of each GIF

    selectedGifPreviewUrl: string;
    selectedGifAnimatedUrl: string;

    //mediaUrls: string[] = [];
    mediaUrls: any[] = [];  // This will include URLs, indexing, and any relevant flags
    gifAnimatedUrls: string[] = []; // Stores animated GIF URLs
    gifPreviewUrls: string[] = []; // Stores preview GIF URLs

    isTenorGif: boolean[] = [];
    activeSlideIndex = 0;
    activeIndex: number = 0;

    responsiveOptions: any[] = [
        {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 1
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
        }
    ];
    hasPostText: boolean = false; // Tracks whether there is post text to enable post button

    /** Feed header tabs (UI); both use the same dashboard feed until a Following API exists. */
    feedTab: 'foryou' | 'following' = 'foryou';

    constructor(
        //private authService: UserService,
        //private globalService: GlobalService,
        private sessionService: SessionService,
        private inactivityService: InactivityTimeoutService,
        private userPostsDataService: UserPostsDataService,
        private userService: UserService,
        private modalService: NgbModal,
        private changeDetectorRef: ChangeDetectorRef,


        private toastr: ToastrService,
        private scrollPositionService: ScrollPositionService,

        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private viewportScroller: ViewportScroller,
        private router: Router
        //private formBuilder: FormBuilder
  ) {
        // Listen to navigation events and prepare to restore scroll position if necessary
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            if (event.url === '/dashboard') {  // Adjust this to your actual dashboard URL
                this.shouldRestoreScrollPosition = true;
            }
        });
        this.scrollEvent.pipe(
            debounceTime(300) // Adjust time based on user experience needs
        ).subscribe(() => {
            this.checkAndLoadMore();
        });
    }

  onApiLogoError(event: Event): void {
      const el = event.target as HTMLImageElement;
      if (el?.src && !el.src.includes('avatar-placeholder.svg')) {
          el.src = this.avatarPlaceholder;
      }
  }

  setFeedTab(tab: 'foryou' | 'following'): void {
      this.feedTab = tab;
  }

  ngOnInit(): void {
    //debugger;
      this.UserPostsData = new Array<Classes.ShortsPosts>();
      this.UserPostsDataContent = new Classes.ShortsPostSave();

      //console.log(this._route.snapshot.queryParams);

      this.sessionService.getUserID().subscribe(userID => {
          this.UserID = Number(userID);
      });

      this.sessionService.getUsername().subscribe(username => {
          this.Username = username;
          //this.isOwnProfile = username === this.Username; // Check if the profile belongs to the logged-in user
      });

      this.sessionService.getUserImg().subscribe(userImg => {
          this.UserImg = userImg;
      });

      // Start the inactivity timeout when the component initializes
      this.inactivityService.initializeTimer();

      //this.route.queryParams.subscribe(params => {
      //    this.currentQuery = params['query']; // Update query param
      //    this.fetchDashboardPosts(); // Fetch posts based on query
      //});

      this.getUserPostsDataNew();
      this.subscribeToScrollEvents();

      //var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
      //var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
      //    return new bootstrap.Dropdown(dropdownToggleEl);
      //});
    }

    ngAfterViewInit() {

        setTimeout(() => {
            const sidebarEl = this.sidebarContent.nativeElement as HTMLElement;
            this.sidebarHeight = sidebarEl.offsetHeight;
            this.viewportHeight = window.innerHeight;
            this.maxMarginTop = Math.max(this.sidebarHeight - this.viewportHeight, 0);
            this.lastScrollY = window.scrollY;
        }, 100);

        this.sidebarReset = false;
        this.sidebarAtBottom = false;
        this.sidebarAtTop = true;


        //console.log('Sidebar Height:', this.sidebarHeight);
        //console.log('Viewport Height:', window.innerHeight);
        //console.log('this.maxMarginTop:', this.maxMarginTop);
        //console.log('this.lastScrollY:', this.lastScrollY);


        //this.measurePositions();

        //************************* */

        // Measure container & sidebar
        //const parentRect = this.sidebarParent.nativeElement.getBoundingClientRect();
        //this.containerTop = parentRect.top + window.scrollY;
        //this.containerHeight = parentRect.height;

        //this.sidebarHeight = this.sidebar.nativeElement.offsetHeight;
        //this.maxOffset = this.containerTop + this.containerHeight - this.sidebarHeight;
        //this.leftOffset = this.sidebarParent.nativeElement.getBoundingClientRect().left;

        //***************** */

        //const sidebarEl = this.sidebarRef.nativeElement as HTMLElement;

        //// measure the initial top offset relative to the page
        //this.initialSidebarTop = sidebarEl.getBoundingClientRect().top + window.scrollY;
        //this.sidebarHeight = sidebarEl.offsetHeight;

        //// If this sidebar is inside a parent container with position: relative, measure that container
        //// For example, if your "home" or parent has an id #mainContainer:
        //// But if the sidebar is simply in the col, you can measure the document height or something else.
        //// We'll do a simpler approach: container = entire doc.
        //this.containerHeight = document.documentElement.scrollHeight;
        //this.containerTop = 0; // or measure a parent
        //this.containerBottom = this.containerTop + this.containerHeight;

        //*********** */

        // Restore scroll position if flagged
        if (this.shouldRestoreScrollPosition) {
            setTimeout(() => {
                const position = this.scrollPositionService.getScrollPosition();
                this.viewportScroller.scrollToPosition(position);
                this.shouldRestoreScrollPosition = false;
            }, 500); // Adjust the timeout as needed
        }

        this.postElements.changes.subscribe(() => {
            this.setupIntersectionObservers();
        });
        this.setupIntersectionObservers();

        let element = document.querySelector('.dropdown-toggle');
        if (element) {
            new bootstrap.Dropdown(element);
        }
    }

    ngAfterViewChecked(): void {
        if (this.shouldRestoreScrollPosition) {
            setTimeout(() => {
                const position = this.scrollPositionService.getScrollPosition();
                this.viewportScroller.scrollToPosition(position);
                this.shouldRestoreScrollPosition = false;
            }, 500); // Adjust the timeout as needed
        }
        //this.setupIntersectionObservers();

        //this.loadTwitterWidgets();

        //if (this.isTwitterWidgetsLoaded) {
        //    window['twttr'] && window['twttr'].widgets.load();
        //}
    }

    ngOnDestroy() {
        this.scrollEventSubscription?.unsubscribe();
    }

    ngOnChanges() {

    }

    private subscribeToScrollEvents() {
        this.scrollEventSubscription = fromEvent(window, 'scroll')
            .pipe(throttleTime(500))
            .subscribe(() => this.onWindowScrollEvent());
    }

    initSidebarScroll(): void {
        this.sidebarHeight = this.sidebarContent.nativeElement.offsetHeight;
        this.viewportHeight = window.innerHeight;
        this.marginTop = 0;
        this.lastScrollY = window.scrollY;

        //console.log('Sidebar Height:', this.sidebarHeight);
        //console.log('Viewport Height:', window.innerHeight);
        //console.log('this.lastScrollY:', this.lastScrollY);

    }

    //@HostListener('window:scroll', ['$event'])
    //onScroll(): void {
    //    this.scrollEvent.next();
    //}

    //private measurePositions(): void {
    //    const sidebarParentEl = this.sidebarParentRef.nativeElement as HTMLElement;
    //    const sidebarEl = this.sidebarRef.nativeElement as HTMLElement;
    //    // Calculate container top relative to page
    //    this.containerTop = sidebarParentEl.getBoundingClientRect().top + window.scrollY;
    //    // Calculate the maximum translation allowed
    //    const containerHeight = sidebarParentEl.getBoundingClientRect().height;
    //    const sidebarHeight = sidebarEl.getBoundingClientRect().height;
    //    this.maxTranslate = Math.max(0, containerHeight - sidebarHeight);
    //}

    //@HostListener('window:resize', [])
    //onResize() {
    //    this.measurePositions();
    //}

    @HostListener('window:scroll', ['$event'])
    onWindowScrollEvent(): void {

        this.scrollEvent.next();

        //******** */
        //const sidebarEl = this.sidebarContent.nativeElement as HTMLElement;

        //const currentScrollY = window.scrollY;
        //const currentScrollYInit = currentScrollY;
        //const delta = currentScrollY - this.lastScrollY;
        //this.lastScrollY = currentScrollY;

        //if (this.sidebarHeight <= 0) {
        //    this.sidebarHeight = sidebarEl.offsetHeight;
        //    this.viewportHeight = window.innerHeight;
        //    this.maxMarginTop = Math.max(this.sidebarHeight - this.viewportHeight, 0);
        //}

        //const scrollThreshold = this.sidebarHeight - this.viewportHeight;

        ////this.sidebarAtBottom = false;
        ////this.sidebarAtTop = true;

        ////if (currentScrollY > currentScrollYInit && !this.sidebarReset) {
        ////    this.sidebarAtTop = false;
        ////}

        //// If not yet at the bottom, no margin-top
        //if (currentScrollY < scrollThreshold && !this.sidebarReset) {
        //    // no margin top
        //    this.marginTop = 0;
        //    //    sidebarEl.style.marginTop = '0px';
        //    sidebarEl.classList.remove('pinned-top');
        //    sidebarEl.classList.remove('pinned-bottom');
        ////    sidebarEl.style.overflowY = 'hidden';
        //}
        //else {
        //    this.sidebarReset = true;
        //    if (delta > 0) {
        //        sidebarEl.classList.remove('pinned-top');

        //        //this.marginTop = Math.min(this.marginTop + delta, this.maxMarginTop);
        //        if (currentScrollY > this.sidebarHeight + this.marginTop) {
        //            this.marginTop += delta;

        //            //if (!this.pinnedBottom) {
        //            //    this.pinnedBottom = true;
        //                // Pinned at bottom
        //                sidebarEl.classList.add('pinned-bottom');
        //            //    sidebarEl.style.overflowY = 'auto';
        //        //    }
        //        }
        //    } else if (delta < 0) {
        //        sidebarEl.classList.remove('pinned-bottom');
        //        if (currentScrollY - this.marginTop < 0) {
        //            this.marginTop = Math.max(this.marginTop + delta, 0);
        //            //if (!this.pinnedTop) {
        //            //    this.pinnedTop = true;
        //                // Pinned at top
        //                sidebarEl.classList.add('pinned-top');
        //            //    sidebarEl.style.overflowY = 'auto'; // user can scroll inside sidebar
        //            //}

        //        }
        //    }

        //} 
        //sidebarEl.style.marginTop = `${this.marginTop}px`;

        //else {
        //    // If we are above the scroll threshold, reset marginTop
        //    this.marginTop = 0;
        //    sidebarEl.style.marginTop = '0px';
        //}

        // Optional: console log for debug
        //console.log('ScrollY:', currentScrollY, '| Threshold:', scrollThreshold, '| marginTop:', this.marginTop);



        //console.log('this.viewportHeight:', this.viewportHeight);
        //console.log('this.sidebarHeight:', this.sidebarHeight);
        //console.log('currentScrollY:', currentScrollY);
        //console.log('this.lastScrollY:', this.lastScrollY);
        //console.log('this.marginTop:', this.marginTop);
        //console.log('this.maxMarginTop:', this.maxMarginTop);
        //console.log('scrollThreshold:', scrollThreshold);
        //console.log('delta:', delta);


        //const sidebar = this.sidebarParent.nativeElement as HTMLElement;
        //const sidebarContent = this.sidebar.nativeElement as HTMLElement;

        //const scrollTop = window.scrollY;
        //const viewportHeight = window.innerHeight;
        //const contentHeight = sidebarContent.getBoundingClientRect().height;
        //const sidebarTop = sidebar.getBoundingClientRect().top + window.scrollY;

        //// Calculate how far the user has scrolled past the top of the sidebar's container:
        //let translation = scrollTop - sidebarTop;
        //if (translation < 0) {
        //    translation = 0;
        //}

        //// Maximum translation allowed so that the bottom of the sidebar aligns with the container bottom:
        //const maxTranslation = contentHeight - viewportHeight;
        //if (translation > maxTranslation) {
        //    translation = maxTranslation;
        //}

        //// If the user hasn't reached the sidebar container yet, reset styles.
        //if (scrollTop < sidebarTop) {
        //    sidebarContent.style.position = '';
        //    sidebarContent.style.transform = '';
        //} else {
        //    // Otherwise, fix the sidebar in the viewport and translate it upward.
        //    sidebarContent.style.position = 'fixed';
        //    sidebarContent.style.top = '0px';
        //    // Optionally, set left so it stays aligned horizontally:
        //    sidebarContent.style.left = sidebar.getBoundingClientRect().left + 'px';
        //    sidebarContent.style.transform = `translateY(-${translation}px)`;
        //}



        //******************** */

        //const sidebar = this.sidebarParent.nativeElement as HTMLElement;
        //const sidebarContent = this.sidebar.nativeElement as HTMLElement;

        //const scrollTop = window.scrollY;
        //const viewportHeight = window.innerHeight;
        //const contentHeight = sidebarContent.getBoundingClientRect().height;
        //const sidebarTop = sidebar.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop);

        //// If scrolled beyond the threshold, pin content at bottom
        //if (scrollTop >= contentHeight - viewportHeight + sidebarTop) {
        //    sidebarContent.style.transform = `translateY(-${contentHeight - viewportHeight + sidebarTop}px)`;
        //    sidebarContent.style.position = 'fixed';
        //} else {
        //    // Otherwise, reset position & transform
        //    sidebarContent.style.transform = '';
        //    sidebarContent.style.position = '';
        //}


        //************************ */

        //const scrollTop = window.scrollY;
        //const sidebarEl = this.sidebar.nativeElement as HTMLElement;

        //if (scrollTop < this.containerTop) {
        //    // top
        //    sidebarEl.style.position = 'absolute';
        //    sidebarEl.style.top = '0px';
        //    sidebarEl.style.left = '0px';
        //} else if (scrollTop > this.maxOffset) {
        //    // bottom
        //    sidebarEl.style.position = 'absolute';
        //    sidebarEl.style.top = (this.containerHeight - this.sidebarHeight) + 'px';
        //    sidebarEl.style.left = '0px';
        //} else {
        //    // in-between
        //    sidebarEl.style.position = 'fixed';
        //    sidebarEl.style.top = '0px';
        //    sidebarEl.style.left = `${this.leftOffset}px`;
        //}    
    }

    updateContentStatus(hasPostText: boolean) {
        this.hasPostText = hasPostText;
    }

    updatePostContentReactions(postContent: any) {
        this.UserPostsDataContent = postContent;
        if (postContent.PostContent && postContent.PostContent.length > 0) {
            this.hasPostText = true;
        }
    }

    updatePostContent(postContent: string) {
        this.UserPostsDataContent.PostContent = postContent;
        if (postContent && postContent.length > 0) {
            this.hasPostText = true;
        }
    }

    updatePostMediaUrls(media: any[]) {
        //this.mediaUrls = media;
        this.mediaUrls = media.map(item => ({ ...item })); // Shallow copy to avoid reference sharing
    //    console.log("HOME this.mediaUrls: ", this.mediaUrls);  // Log the entire event to see what properties are available
    }

    updateReplyType(type: any) {
        this.selectedReplyType = type;
    }

    removeMediaFromFooter(index: number): void {
        if (this.footerComponent) {
            this.footerComponent.removeMediaAtIndex(index);
        } else {
            console.error("FooterComponent not initialized yet.");
        }
    }

    private checkAndLoadMore(): void {
        // Your existing onScroll logic here...
        this.showProfileBox = false;
        this.showTooltip = false;
        // Clear the timeoutId after it executes
        this.timeoutId = null;
        this.hoverTimer = null;

        if (this.isLoading || this.allPostsLoaded) return;

        const nearToEndIndex = Math.max(this.UserPostsData.length - 3, 0);
        const triggerElementId = `post${(this.currentPage - 1) * this.pageSize + nearToEndIndex}`;
        const triggerElement = document.getElementById(triggerElementId);

        if (triggerElement && (window.scrollY + window.innerHeight > triggerElement.offsetTop) && !this.isLoading) {
            this.currentPage++;
            this.getUserPostsDataNew();
        }

    }

    //updateActiveIndex(newIndex: number): void {
    updateActiveIndex(event: any): void {
        //    this.activeIndex = newIndex;
        //alert(newIndex);
        //    console.log("Updated active index: ", this.activeIndex);

        //console.log(event);  // Log the entire event to see what properties are available
        this.activeIndex = event.page;  // Assuming 'page' is the correct property
    }

    get isAtStart(): boolean {
        //console.log("isAtStart activeIndex: " + this.activeIndex);  // Log the entire event to see what properties are available

        if (this.activeIndex === 22 || this.activeIndex === 0) {
            return true;
        };
        return false;

    }

    get isAtEnd(): boolean {
        //console.log("isAtEnd mediaUrls.length: " + this.mediaUrls.length);  // Log the entire event to see what properties are available
        //console.log("isAtEnd activeIndex: " + this.activeIndex);  // Log the entire event to see what properties are available
        if (this.mediaUrls.length === 2 && this.activeIndex === 0) {
            return true;
        }

        if (this.mediaUrls.length === 3 && this.activeIndex === 32 ) {
            return true;
        }
        else if (this.mediaUrls.length === 4 && this.activeIndex === 42) {
            return true;
        }
        return false;
    }

    //loadUserProfile_home(UserName: any, index: number, event: MouseEvent) {
    //    //console.log(`Mouse over: index ${index}`);

    //    event.stopPropagation(); // Add this to prevent event bubbling

    //    // Check the class of the event target to determine which functionality to trigger
    //    const target = event.target as HTMLElement;
    //    if (target.classList.contains('publish-date')) {
    //        // Logic for showing the date tooltip
    //        this.hoverTimer = setTimeout(() => {
    //            this.showTooltip = true;
    //        }, 1000);  // Delay in milliseconds
    //    } else {
    //        this.hoverTimer = setTimeout(() => {
    //            if (!this.userProfileStates.has(index)) {
    //                this.userProfileStates.set(index, { visible: false });
    //            }

    //            this.userService.getUserProfile(UserName).subscribe(data => {
    //                const element = event.target as HTMLElement;
    //                const rect = element.getBoundingClientRect();

    //                // Calculate available space below the link
    //                const spaceBelow = window.innerHeight - rect.bottom;
    //                const hoverBoxHeight = 200; // Assume a fixed height or calculate dynamically

    //                if (spaceBelow < hoverBoxHeight) {

    //                    // Not enough space below, position above
    //                    this.hoverBoxStyle = {
    //                        bottom: `30px` // Position above the link
    //                    };
    //                }
    //                else {
    //                    this.hoverBoxStyle = {
    //                        top: `30px` // Position above the link
    //                    };
    //                }

    //                this.userProfileStates.get(index).profile = data;
    //                this.userProfileStates.get(index).visible = true;

    //                this.showProfileBox = true;
    //                //console.log("this.showProfileBox : " + this.showProfileBox );
    //            });
    //        }, 1000); // Delay of 1000 milliseconds (1 second)
    //    }
    //}

    //hideUserProfile_home(index: number) {
    //    //console.log(`Mouse leave: index ${index}`);

    //    clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
    //    this.showTooltip = false;
    //    this.showProfileBox = false;
    //    if (this.userProfileStates.has(index)) {
    //        this.userProfileStates.get(index).visible = false;
    //    }
    //}

    getUniqueScoreTypes(scoreDetailsList: Classes.ScoreDetails[]): Classes.ScoreDetails[] {
        const uniqueScoreTypes = [];
        const scoreTypeIDs = new Set();
        for (const scoreDetails of scoreDetailsList) {
            if (!scoreTypeIDs.has(scoreDetails.ScoreTypeID)) {
                scoreTypeIDs.add(scoreDetails.ScoreTypeID);
                uniqueScoreTypes.push(scoreDetails);
            }
        }
        return uniqueScoreTypes;
    }

    getReasonDetails(postID: number): Classes.ReasonDetail[] {
        const scoreDetails = this.selectedScoreDetails[postID];
        if (scoreDetails && scoreDetails.length > 0) {
            return scoreDetails[0].ReasonDetails;
        }
        return [];
    }

    isBadgeSelected(postId: number, scoreTypeId: number): boolean {
        return this.selectedPostId === postId && this.selectedScoreTypeId === scoreTypeId;
    }

    selectScore(postData: any, scoreTypeID: number, event: Event): void {
        event.stopPropagation();
        const postID = postData.TSID;
        this.selectedScoreTypeIDs[postID] = scoreTypeID;
        this.selectedScoreDetails[postID] = postData.ScoreDetailsList.filter(
            (scoreDetails) => scoreDetails.ScoreTypeID === scoreTypeID
        );
        this.showDetails[postID] = false; // Reset details view
    }

    toggleDetails(postID: number) {
        this.showDetails[postID] = !this.showDetails[postID];
    }

    //toggleDetails(index: number): void {
    //    if (this.showDetailsIndex === index) {
    //        this.showDetailsIndex = null; // Close if already open
    //    } else {
    //        this.showDetailsIndex = index; // Open the selected details
    //    }
    //}


    //toggleDetails(postId: number, scoreTypeId: number): void {
    //    if (this.selectedPostId === postId && this.selectedScoreTypeId === scoreTypeId) {
    //        // If the same badge is clicked, toggle it off
    //        this.selectedPostId = null;
    //        this.selectedScoreTypeId = null;
    //    } else {
    //        // Select a new badge
    //        this.selectedPostId = postId;
    //        this.selectedScoreTypeId = scoreTypeId;
    //    }
    //}

    loadTwitterWidgets(): void {
        const script = document.createElement('script');
        script.src = 'https://platform.twitter.com/widgets.js';
        script.async = true;
        script.charset = 'utf-8';
        document.head.appendChild(script);
    }

    setupIntersectionObservers(): void {
        if (this.postElements && this.postElements.length > 0) {
            this.postElements.forEach((postElement) => {
                this.setupIntersectionObserver(postElement);
            });
        }
    }

    setupIntersectionObserver(postElement: ElementRef): void {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const postContent = (entry.target as HTMLElement).innerHTML;
                    if (this.isTwitterPost(postContent)) {
                        this.loadTwitterWidgets();
                    }
                    if (this.isFacebookPostType(postContent)) {
                        this.loadFacebookWidgets(entry.target as HTMLElement);
                    }
                    obs.unobserve(entry.target); // Ensure the element is unobserved after being intersected
                    //observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        if (postElement.nativeElement instanceof HTMLElement) {
            observer.observe(postElement.nativeElement);
        }
    }

    isTwitterPost(content: string): boolean {
        return content.includes('twitter-tweet');
    }

    isFacebookPostType(content: string): boolean {
        const facebookPatterns = ['facebook.com', 'fb.watch'];
        return facebookPatterns.some(pattern => content.includes(pattern));
    }

    isFacebookPost(content: string): boolean {
        const facebookPatterns = ['post.php'];
        return facebookPatterns.some(pattern => content.includes(pattern));
    }

    isFacebookEmbeddedPost(content: string): boolean {
        const facebookPatterns = ['iframe'];
        return facebookPatterns.some(pattern => content.includes(pattern));
    }

    //loadTwitterWidgets(): void {
    //    if (window['twttr'] && window['twttr'].widgets) {
    //        window['twttr'].widgets.load();
    //    } else {
    //        const script = document.createElement('script');
    //        script.src = 'https://platform.twitter.com/widgets.js';
    //        script.async = true;
    //        script.charset = 'utf-8';
    //        document.head.appendChild(script);
    //    }
    //}

    loadFacebookWidgets(element: HTMLElement): void {
        if (window['FB'] && window['FB'].XFBML) {
            window['FB'].XFBML.parse();
            this.resizeFacebookIframes(element);
        } else {
            const script = document.createElement('script');
            script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v11.0';
            //script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2';
            script.async = true;
            script.defer = true;
            script.crossOrigin = 'anonymous';
            script.onload = () => {
                window['FB'].XFBML.parse();
                //this.resizeFacebookIframes(element);
                this.observeFacebookIframes(element);
            };
            document.head.appendChild(script);
        }
    }

    resizeFacebookIframes(element: HTMLElement): void {
        const iframes = element.querySelectorAll('iframe');
        iframes.forEach((iframe: HTMLIFrameElement) => {
            iframe.style.width = '100%';
            //iframe.style.height = 'auto';
            iframe.style.borderRadius = '0.85rem';

            //const resizeObserver = new ResizeObserver(entries => {
            //    for (let entry of entries) {
            //        if (entry.target instanceof HTMLIFrameElement) {
            //            entry.target.style.height = entry.contentRect.height + 'px';
            //        }
            //    }
            //});

            //resizeObserver.observe(iframe);
        });
    }

    observeFacebookIframes(element: HTMLElement): void {
        const fbPosts = element.querySelectorAll('.fb-post-embedded');
        fbPosts.forEach((fbPost: HTMLElement) => {
            const resizeObserver = new ResizeObserver(() => {
                this.adjustIframeHeight(fbPost);
            });

            resizeObserver.observe(fbPost);
        });
    }

    adjustIframeHeight(fbPost: HTMLElement): void {
        try {
            const iframe = fbPost.querySelector('iframe');
            if (iframe) {
                //iframe.style.height = (fbPost.clientHeight*.958) + 'px';
                iframe.style.width = '100%';
                iframe.style.borderRadius = '0.85rem';
            }
        } catch (error) {
            console.warn('Could not access iframe content due to cross-origin restrictions', error);
        }
    }

    getFacebookPostHref(content: string): string {
        console.log('Post Content:', content); // Debugging line to check content
        // Adjust regex to be more flexible with possible variations
        const match = content.match(/data-href=['"]([^'"]+)['"]/);
        const href = match ? match[1] : '';
        console.log('Extracted Href:', href); // Debugging line to check extracted href
        return href;
    }

    sanitizeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    onReactionsUpdated(postId: number, updatedReactions: any): void {
        const post = this.UserPostsData.find(p => p.TSID === postId);
        if (post) {
            post.Reactions = updatedReactions;
        }
    }

    getUserPostsDataNew(refresh: boolean = false) {
        this.isLoading = true;
        let postTypes: number[] | undefined;
        // For User Profile Posts, I gather Original - 1; Reposts - 2; and Quotes - 3; Replies - 4; Quotes - 5
        // For User Profile Posts, I gather Twitter Admin Post - 20;
        postTypes = [1, 2, 3, 5, 20, 21]; // Specify the actual types you need
        const query = this.route.snapshot.queryParams['q']; // Grab query from route

        this.userPostsDataService.getDashboardPosts(this.UserID, this.currentPage, this.pageSize, postTypes, query).subscribe({
        //this.userPostsDataService.getDashboardPosts(this.UserID, this.currentPage, this.pageSize).subscribe({
            next: posts => {
                // Append or replace posts based on the `refresh` flag
                this.UserPostsData = refresh ? posts : this.UserPostsData.concat(posts);
                //console.log('UserPostsData Updated:', this.UserPostsData);

                // Select the first badge and show details by default for each post
                this.UserPostsData.forEach(post => {
                    if (post.ScoreDetailsList && post.ScoreDetailsList.length > 0) {
                        const firstScoreTypeID = post.ScoreDetailsList[0].ScoreTypeID;
                        this.selectedScoreDetails[post.TSID] = post.ScoreDetailsList.filter(sd => sd.ScoreTypeID === firstScoreTypeID);
                        this.selectedScoreTypeID = firstScoreTypeID;
                        this.showDetails[post.TSID] = true; // Set showDetails for each post
                    }
                });

                this.isLoading = false;
                if (posts.length < this.pageSize) { // Less data than expected
                    this.allPostsLoaded = true; // Assume all posts are loaded
                }
            },
            error: error => {
                console.error('There was an error!', error);
                this.isLoading = false;
            }
        });
    }

    loadReactions(postId: number) {
        this.userPostsDataService.getReactions(postId).subscribe(data => {
            this.reactions = data;
        });
    }

    toggleReaction(postId: number, type: '1' | '2' | '3'): void {
        this.userPostsDataService.toggleReaction(postId, this.UserID, type).subscribe(updatedReactions => {
            const post = this.UserPostsData.find(p => p.TSID === postId);
            if (post) {
                post.Reactions = updatedReactions; // Update the reactions with the returned data
                // Toggle the selected state for the specific reaction type
                //switch (type) {
                //    case 'reply':
                //        post.Reactions.replySelected = !post.Reactions.replySelected;
                //        break;
                //    case 'repost':
                //        post.Reactions.repostSelected = !post.Reactions.repostSelected;
                //        break;
                //    case 'like':
                //        post.Reactions.likeSelected = !post.Reactions.likeSelected;
                //        break;
                //}
            }
        }, error => {
            console.error('Error toggling reaction:', error);
        });
    }

    onFollowStatusChanged(event: { userId: number, isFollowed: boolean }) {
        this.UserPostsData.forEach(post => {
            if (post.UserID === event.userId) {
                post.IsFollowed = event.isFollowed;
            }
        });
    }

    submitPost() {

        // Call checkVideo with the mock event
        //this.checkVideo(event as any);

        this.UserPostsDataContent.UserID = this.UserID;
        this.UserPostsDataContent.PostType = 1;
        this.UserPostsDataContent.PublishDate = new Date() // Date is set at the time of submission
        this.UserPostsDataContent.ReplyType = this.replyType;

        if (this.selectedFile.name.length > 0 ) {
            this.UserPostsDataContent.FileName = this.selectedFile.name;
            this.UserPostsDataContent.VideoMimeType = this.selectedFile.type;
        }

        const formData = new FormData();

        formData.append('postData', JSON.stringify(this.UserPostsDataContent)); // Serialize your object into a JSON string
        if (this.selectedFile) {
            formData.append('file', this.selectedFile, this.selectedFile.name);
        }


        this.userPostsDataService.saveUserPostsData(formData).subscribe(data => {
            if (data.type === HttpEventType.DownloadProgress) {
                let percentDone: number = Math.round(100 + data.loaded / data.total);
                if (percentDone > 100) {
                    percentDone = 100;
                }
                else if (percentDone < 0) {
                    percentDone = 0;
                }
            } else if (data instanceof HttpResponse) {
                let loadedData: number = data.body;
                //var x = loadedData;

                //this.ProfileIconImage = this.UserPostsData.

                //this.FraudIncidentData = data.body.map(x => Object.assign({}, x));

                //this.FraudIncidentData.forEach((elem: any) => {
                //console.log(elem);
                //});

            }
        })
    };

    savePost(): void {

        this.UserPostsDataContent.UserID = this.UserID;
        this.UserPostsDataContent.PostType = 1;
        this.UserPostsDataContent.PublishDate = new Date() // Date is set at the time of submission
        this.UserPostsDataContent.ReplyType = this.selectedReplyType.id; // Save replyType selection

        const formData = new FormData();

        formData.append('postData', JSON.stringify(this.UserPostsDataContent)); // Serialize your object into a JSON string

        // Add each media file or URL
        this.mediaUrls.forEach((mediaItem, index) => {
            if (!mediaItem.isTenor) {
                // Append local file
                formData.append(`file_${index}`, mediaItem.file!, mediaItem.file!.name);
                formData.append('mimeType', mediaItem.mimeType!);
            } else {
                // Append Tenor URL and Animated URL concatenated with a delimiter (e.g., `|`)
                const combinedUrl = `${mediaItem.url}|${mediaItem.animatedUrl}`;
                formData.append(`gifUrl_${index}`, combinedUrl);
            }
        });

        // Call service to save post
        this.userPostsDataService.savePost(formData, this.UserID).subscribe({
            next: (response) => {
                //console.log('Post saved successfully', response);
                this.toastr.success('Post saved successfully!');

                // Emit the event to refresh posts
                //this.postSaved.emit();

                // Reset post content and media URLs
                this.UserPostsDataContent.PostContent = '';
                this.mediaUrls = [];

                // Just refresh the posts
                this.getUserPostsDataNew(true);
            },
            error: (error) => {
                //console.error('Error saving post', error);
                this.toastr.error('Error saving post!');
            }
        });
    }      


    // Method to trigger the file input click event
    triggerFileUpload(): void {
        document.getElementById('videoUpload')!.click();
    }

    checkVideo(event: any): void {
        this.selectedFile = event.target.files[0];

        if (!this.selectedFile) {
            return;
        }
        const mimeType = this.selectedFile.type; // Extract the MIME type

        // Clear the file input to allow re-upload of the same file if necessary
        event.target.value = '';

        // Handle video files separately
        if (this.selectedFile.type.startsWith('video/')) {
            // Check the file type
            if (this.selectedFile.type !== 'video/mp4' && this.selectedFile.type !== 'video/quicktime') {
                alert('Unsupported video format. Please upload a MP4 or MOV file.');
                return;
            }

            // Load the file into a video element to check duration
            const video = document.createElement('video');
            video.preload = 'metadata';

            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                const duration = video.duration;

                if (duration > 120) { // Check if video is longer than 2 minutes
                    alert('Video is too long. Maximum allowed duration is 2 minutes.');
                } else {
                    //alert('Video is valid. Duration: ' + duration + ' seconds.');

                    const index = this.mediaUrls.length; // Get the next index
                    const mediaItem = {
                        //url: URL.createObjectURL(this.selectedFile),
                        url: URL.createObjectURL(this.selectedFile),
                        file: this.selectedFile,
                        isVideo: true,
                        isTenor: false,  // Assuming you're handling only local files here
                        isPlaying: false,  // Not relevant for local files, but keeping the structure consistent
                        animatedUrl: null, // Not applicable for local files
                        previewUrl: null,   // For local files, the preview and actual URLs are the same
                        mimeType: mimeType, // Store the extracted MIME type
                        index: index       // Tracking the index of the new item
                    };

                    this.mediaUrls.push(mediaItem);
                    // Reset the file input
                    event.target.value = '';

                    //this.generateThumbnail(this.selectedFile, (thumbnailUrl: string) => {
                    //    this.handleFileSelect(thumbnailUrl);
                    //    console.log('Thumbnail URL:', thumbnailUrl);
                    //});

                    // Proceed with further processing like uploading
                }
            };

            video.onerror = () => {
                alert('Unable to load the video for validation.');
            };
            video.src = URL.createObjectURL(this.selectedFile);

        } else if (this.selectedFile.type.startsWith('image/')) {
            // Handle image file (non-video)
            const reader = new FileReader();
            reader.onload = (e: any) => {
                //this.handleFileSelect(e.target.result);
                const index = this.mediaUrls.length; // Get the next index
                const mediaItem = {
                    url: URL.createObjectURL(this.selectedFile),
                    file: this.selectedFile,
                    isVideo: false,
                    isTenor: false,  // Assuming you're handling only local files here
                    isPlaying: false,  // Not relevant for local files, but keeping the structure consistent
                    animatedUrl: null, // Not applicable for local files
                    previewUrl: null,   // For local files, the preview and actual URLs are the same
                    mimeType: mimeType, // Store the extracted MIME type
                    index: index       // Tracking the index of the new item
                };

                this.mediaUrls.push(mediaItem);
                // Reset the file input
                event.target.value = '';


            };
            reader.readAsDataURL(this.selectedFile);
        }

    }

    generateThumbnail(file: File, callback: (thumbnailUrl: string) => void): void {
        const video = document.createElement('video');
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        video.onloadedmetadata = () => {
            // Seek to middle of the video
            video.currentTime = video.duration / 2;
        };

        video.onseeked = () => {
            // Draw the current frame to the canvas
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context!.drawImage(video, 0, 0, canvas.width, canvas.height);

            // Convert canvas to data URL
            const thumbnailUrl = canvas.toDataURL('image/jpeg');
            callback(thumbnailUrl);

            // Clean up
            video.src = ""; // Release video src
            URL.revokeObjectURL(video.src);
        };

        video.onerror = () => {
            console.error('Error loading video file.');
            video.src = ""; // Ensure to release video src
        };

        video.src = URL.createObjectURL(file);
    }

    uploadVideo(file: File): void {
        const formData = new FormData();
        formData.append('video', file);

        //this.http.post('https://yourserver.com/upload', formData).subscribe(
        //    response => {
        //        console.log('Upload successful', response);
        //    },
        //    error => {
        //        console.error('Upload failed', error);
        //    }
        //);
    }

    navigateToPost(username: string, postId: number): void {
        // Save the current scroll position
        const currentPosition = this.viewportScroller.getScrollPosition();
        this.scrollPositionService.setScrollPosition(currentPosition);

        this.router.navigate([`${username}/posts/${postId}`]);
    }

    navigateToPage() {
        // changes the route without moving from the current view or
        // triggering a navigation event,
          this.router.navigate(['/dashboard_login'], {
          relativeTo: this.route,
          //queryParams: {
          //  stateIDParams: '1'
          //},
          // preserve the existing query params in the route
          //queryParamsHandling: 'merge',

          // do not trigger navigation
          skipLocationChange: true

        });
    }

    //openGifModal(): void {
    //    const modalRef = this.modalService.open(GifModalComponent, { size: 'lg' });
    //    //modalRef.componentInstance.gifSelected.subscribe((gif: any) => {
    //    //    this.selectedGifUrl = gif.media[0].tinygif.url; // Assuming the structure of the GIF data
    //    //    console.log('Received GIF URL:', this.selectedGifUrl);
    //    //});
    //    modalRef.componentInstance.gifSelected.subscribe((selectedGifUrl: string) => {
    //        this.selectedGifUrl = selectedGifUrl; // Directly use the URL string received
    //        console.log('Received GIF URL:', this.selectedGifUrl);
    //    });
    //}

    openGifModal(): void {
        if (this.mediaUrls.length >= 4) return;
        const modalRef = this.modalService.open(GifModalComponent, { size: 'lg' });
        modalRef.componentInstance.gifSelected.subscribe((gifData: { previewUrl: string; animatedUrl: string }) => {
            // Set the URLs from the received object
            this.selectedGifPreviewUrl = gifData.previewUrl;
            this.selectedGifAnimatedUrl = gifData.animatedUrl;

            //this.handleGifSelected(gifData, this.mediaUrls.length);
            this.handleGifSelected(gifData);

            ////this.mediaUrls.push(gifData.previewUrl); // Initial display is the preview
            //this.isPlaying.push(false); // Initialize as not playing

        });
    }


    setReplyType(replyType: any) {
        this.selectedReplyType = replyType;
    }

    adjustTextareaHeight(event: any): void {
        event.target.style.height = 'auto';
        event.target.style.height = event.target.scrollHeight + 'px';
    }

    // Method to update URLs after selecting a GIF
    //handleGifSelected(gifData: { previewUrl: string; animatedUrl: string }, index: number): void {
    handleGifSelected(gifData: { previewUrl: string; animatedUrl: string }): void {
        //this.gifPreviewUrls[index] = gifData.previewUrl;
        //this.gifAnimatedUrls[index] = gifData.animatedUrl;
        //this.mediaUrls[index] = gifData.previewUrl; // Start with the preview URL
        //this.isPlaying[index] = false; // Ensure playback is not active initially
        //this.isTenorGif[index] = true; // Identify as a GIF from Tenor

        const index = this.mediaUrls.length;
        const newItem = {
            url: gifData.previewUrl,
            isTenor: true,
            isPlaying: false,
            animatedUrl: gifData.animatedUrl,
            previewUrl: gifData.previewUrl,
            index: index  // Keeping track of item's index
        };
        this.mediaUrls.push(newItem);
    }

    // Check if URL is a GIF (for display logic)
    isGifUrl(url: string, index: number): boolean {
        return this.isTenorGif[index];
    }

    //togglePlay(): void {
    //    this.isPlaying = !this.isPlaying;
    //    // Optionally toggle the image source directly if needed
    //    this.selectedGifUrl = this.isPlaying ? this.selectedGifAnimatedUrl : this.selectedGifPreviewUrl;
    //}

    // Toggle play/pause for GIF at specific index
    togglePlay(index: number): void {
        //this.isPlaying[index] = !this.isPlaying[index];

        const item = this.mediaUrls[index];
        if (item.isTenor) {
            item.isPlaying = !item.isPlaying;
        }
    }

    // Methods to handle media selection should update `mediaUrls`
    //handleFileSelect(url: string, index: number): void {
    handleFileSelect(url: string): void {
        // Assuming mediaUrls, isTenorGif, and isPlaying have been initialized properly
        //if (url) {
        //    if (index >= this.mediaUrls.length) {  // If the index is new, initialize properties
        //        this.mediaUrls.push(url);
        //        this.isTenorGif.push(false); // It's a local file, not a Tenor GIF
        //        this.isPlaying.push(false); // Not relevant for local files, but keeping the structure consistent
        //    } else {  // Otherwise, update existing properties
        //        this.mediaUrls[index] = url;
        //        this.isTenorGif[index] = false;
        //        this.isPlaying[index] = false;
        //    }
        //}
        if (url) {
            const index = this.mediaUrls.length; // Get the next index
            console.log("index size of mediaUrls: " + index);
            const newItem = {
                url: url,
                isTenor: false,
                isPlaying: false,  // Not relevant for local files, but keeping the structure consistent
                animatedUrl: null, // Not applicable for local files
                previewUrl: url,   // For local files, the preview and actual URLs are the same
                index: index       // Tracking the index of the new item
            };
            this.mediaUrls.push(newItem); // Add the new item to the mediaUrls array
        }


    }

    handleGifSelect(url: string) {
        this.selectedGifUrl = url;
        this.updateMediaUrls();
    }

    updateMediaUrls() {
        this.mediaUrls = [];
        if (this.selectedFileUrl) {
            this.mediaUrls.push(this.selectedFileUrl);
        }
        if (this.selectedGifUrl) {
            this.mediaUrls.push(this.selectedGifUrl);
        }
    }

    removeUploadedMedia() {
        this.selectedFileUrl = '';
        this.updateMediaUrls();
    }

    // Handle removal at specific index
    removeMediaAtIndex(index: number): void {
        //this.mediaUrls.splice(index, 1);
        //this.gifAnimatedUrls.splice(index, 1);
        //this.gifPreviewUrls.splice(index, 1);
        //this.isPlaying.splice(index, 1);

        //this.mediaUrls.splice(index, 1);
        //// Reassign indices
        //this.mediaUrls.forEach((item, idx) => item.index = idx);

        console.log(`Deleting item at index ${index}`);  // Debugging output
        if (index > -1 && index < this.mediaUrls.length) {
            this.mediaUrls.splice(index, 1);
            this.mediaUrls = [...this.mediaUrls];  // Re-assign to trigger change detection
            console.log(`Remaining items: ${this.mediaUrls.length}`);  // Check remaining items

            // Manually trigger change detection
            //    this.changeDetectorRef.detectChanges();

            // After removing the item, check if the index is still valid
            if (index >= this.mediaUrls.length) {
                // If the index is out of bounds (e.g., last item was deleted), adjust it
                index = this.mediaUrls.length - 1;
            }

            // Manage focus after a slight delay to allow UI updates
            setTimeout(() => {
                this.focusOnCarouselItem(index);
            }, 100);

        }
    }

    focusOnCarouselItem(index: number): void {
        const carouselItemElements = document.querySelectorAll('.carousel-item-focusable');
        if (carouselItemElements[index]) {
            (carouselItemElements[index] as HTMLElement).focus();
        }
    }

    removeMedia() {
        this.selectedGifUrl = '';
        this.updateMediaUrls();
    }

    //next(): void {
    //    if (this.activeSlideIndex < this.mediaUrls.length - 1) {
    //        this.activeSlideIndex++;
    //    }
    //}

    //previous(): void {
    //    if (this.activeSlideIndex > 0) {
    //        this.activeSlideIndex--;
    //    }
    //}

    next(): void {
        const maxIndex = Math.ceil(this.mediaUrls.length / 2) - 1;
        if (this.activeSlideIndex < maxIndex) {
            this.activeSlideIndex++;
        }
    }

    previous(): void {
        if (this.activeSlideIndex > 0) {
            this.activeSlideIndex--;
        }
    }

    testToastr(): void {
        this.toastr.success('Toastr is working!');
    }

}
